import { CategorySummaryRowProps } from 'spw-projects/esa/program-summary/cards/category-summary-row';
import {
  AMENITY_SPACES_CATEGORY,
  MEETING_SPACES_CATEGORY,
  SUPPORT_SPACES_CATEGORY,
} from 'spw-constants';

export const MEETING_SPACES_ID = 2;
export const AMENITY_SPACES_ID = 3;
export const SUPPORT_SPACES_ID = 4;

type CategorySummaryRowsTexts = {
  [key: string | number]: Omit<
    CategorySummaryRowProps,
    | 'innerRef'
    | 'viewOnly'
    | 'currentProject'
    | 'categorySpacesBreakdown'
    | 'projectColors'
    | 'spaceTypeCategory'
    | 'onClickSpaceIcon'
    | 'projectSpaceTypes'
    | 'projectSpaceTypeCategories'
    | 'rightSubtitle'
    | 'leftSubtitle'
    | 'clientFacingNamesAreVisible'
  >;
};

export const CATEGORY_SUMMARY_ROWS_TEXTS: CategorySummaryRowsTexts = {
  [MEETING_SPACES_ID]: {
    leftGridDataTestId: 'esa_summary_meeting_workspaces_workspace_usf_mix',
    rightGridDataTestId: 'esa_summary_meeting_workspaces_meeting_space_ratio',
  },
  [AMENITY_SPACES_ID]: {
    leftGridDataTestId: 'esa_summary_amenity_workspaces_workspace_usf_mix',
    rightGridDataTestId: 'esa_summary_amenity_workspaces_amenity_space_ratio',
  },
  [SUPPORT_SPACES_ID]: {
    leftGridDataTestId: 'esa_summary_support_workspaces_workspace_usf_mix',
    rightGridDataTestId: 'esa_summary_support_workspaces_support_space_ratio',
  },
};

export const CATEGORY_SUMMARY_ROWS_TEXTS_NEW: CategorySummaryRowsTexts = {
  [MEETING_SPACES_CATEGORY]: {
    leftGridDataTestId: 'esa_summary_meeting_workspaces_workspace_usf_mix',
    rightGridDataTestId: 'esa_summary_meeting_workspaces_meeting_space_ratio',
  },
  [AMENITY_SPACES_CATEGORY]: {
    leftGridDataTestId: 'esa_summary_amenity_workspaces_workspace_usf_mix',
    rightGridDataTestId: 'esa_summary_amenity_workspaces_amenity_space_ratio',
  },
  [SUPPORT_SPACES_CATEGORY]: {
    leftGridDataTestId: 'esa_summary_support_workspaces_workspace_usf_mix',
    rightGridDataTestId: 'esa_summary_support_workspaces_support_space_ratio',
  },
};
